
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
const PageConst= {
  ACTION: {
    doDelete: { api: 'M0040TimeLimitService.M21301_doDelete' },
    doBrowse: { api: 'M0040TimeLimitService.M21301_doBrowse' },
    getEdit: { api: 'M0040TimeLimitService.M21301_getEdit'},
    doEdit: { api: 'M0040TimeLimitService.M21301_doEdit'},
    doAdd: { api: 'M0040TimeLimitService.M21301_doAdd'},
    getTimeLimitCount: {
      api: 'M0040TimeLimitService.getTimeLimitCount'
    },
    getDataForAddingTimeLimit: {
      api: 'M0040TimeLimitService.getDataForAddingTimeLimit'
    },
  },
}

const module = {
  state: {
    PageConst,
    total_row_count : 0,
  },
  getters: {
    getDropdownList (state){
      return {
        notification_type: [
          { label: window.vue.$i18n.t('M21301.time_division_0'), value: 0 },
          { label: window.vue.$i18n.t('M21301.time_division_1'), value: 1 },
          { label: window.vue.$i18n.t('M21301.time_division_2'), value: 2 }
        ]
      }
    },
  },
  mutations: {},
  actions: {
    async M21301_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M21301_getTimeLimitCount({dispatch, state}) {
      return await $this.$api.postData({
        data: [
          { api: 'M0040TimeLimitService.getTimeLimitCount'},
        ]
      })
    },
     async M21301_getDataForAddingTimeLimit({dispatch, state}) {
      return await $this.$api.postData({
        data: [
          { api: 'M0040TimeLimitService.getDataForAddingTimeLimit'},
        ]
      })
    },
    async M21301_doAdd({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0040TimeLimitService.M21301_doAdd', input: payload },
        ]
      })
    },
    async M21301_getEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0040TimeLimitService.M21301_getEdit', input: payload },
        ]
      }).then((res) => {
        return res[0].output;
      })
    },
    async M21301_doEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M0040TimeLimitService.M21301_doEdit', input: payload },
        ]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
